import device from '@service-victoria/component-library/utils/device';
import styled from 'styled-components';

export const ContentContainer = styled.div`
  margin-top: 50px;
  padding: 0 20px;

  @media ${device.isDesktop} {
    padding: 0 50px 42px;
  }
`;

export const CenterAlign = styled.div`
  width: 100%;
  text-align: center;
`;
